/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_PrimaryInputs */

const ja_playdata_nav_primary = /** @type {(inputs: Playdata_Nav_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA ナビゲーション`)
};

const en_playdata_nav_primary = /** @type {(inputs: Playdata_Nav_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA navigation`)
};

/**
* | output |
* | --- |
* | "PLAYDATA navigation" |
*
* @param {Playdata_Nav_PrimaryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_primary = /** @type {((inputs?: Playdata_Nav_PrimaryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_PrimaryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_primary(inputs)
	return en_playdata_nav_primary(inputs)
});